import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { Card, CardSection } from "@mantine/core";
import type { ReactNode } from "react";

export interface IContainerCardProps {
  title?: string | ReactNode;
  children?: ReactNode;
  fullWidth?: boolean;
  classNames?: {
    root?: string;
    title?: string;
    wrapper?: string;
  };
}

const ContainerCard: React.FC<IContainerCardProps> = ({
  title,
  children,
  fullWidth = false,
  classNames,
}) => {
  return (
    <Card
      withBorder
      classNames={{
        root: `text-pretty bg-primary-client border-primary-light ${fullWidth ? "w-full flex-1" : "w-fit"} ${classNames?.root}`,
      }}
      padding={"none"}
    >
      {title && (
        <Card.Section
          classNames={{
            section: `text-pretty p-4 bg-primary-background border-b-[1px] border-primary-light ${classNames?.title}`,
          }}
        >
          <SSWhiteText fz={20} fw={"bold"} className="text-pretty">
            {title}
          </SSWhiteText>
        </Card.Section>
      )}
      <CardSection
        className={`h-full justify-center space-y-2 text-pretty bg-primary-client p-4 ${classNames?.wrapper}`}
      >
        {children}
      </CardSection>
    </Card>
  );
};

export default ContainerCard;
